/**
 * Delay in milliseconds for search input in various modules.
 */

export const DEBOUNCE_INPUT_DELAY = 500;
